export default __webpack_public_path__ + "static/media/danone.51cbf086.png";